import React from "react";
import { Goals } from "../../models/Goals";
import CardCotainer, { Card } from "../../ui-elements/CardContainer/CardContainer";

import activity1 from '../../assets/activity-1.png';
import activity2 from '../../assets/activity-2.png';
import activity3 from '../../assets/activity-3.png';
import activity4 from '../../assets/activity-4.png';
import { AnalyticsApi } from "../../api/user";

interface ActivityProp {
	goal: Goals;
	valueSelected(response?: any): void;
}

const Activity: React.FC<ActivityProp> = ({ goal, valueSelected }): JSX.Element => {
	const [selectedIndex, setSelectedIndex] = React.useState(typeof goal.activity !== "undefined" ? goal.activity : -1);
	const [enabled, setEnabled] = React.useState(false);
	const activities: Card[] = [
		{
			index: 0,
			imageUrl: activity1,
			title: "Very Light",
			body: "Sitting most of the day (example: desk job).",
		},
		{
			index: 1,
			imageUrl: activity2,
			title: "Light",
			body: "A mix of sitting, standing, and light activity (example: teacher).",
		},
		{
			index: 2,
			imageUrl: activity3,
			title: "Moderate",
			body: "Continuous gentle to moderate activity (example: restaurant server).",
		},
		{
			index: 3,
			imageUrl: activity4,
			title: "Heavy",
			body: "Strenuous activity throughout the day (example: construction work).",
		},
	];

	const cardClicked = (index: number) => {
		goal.setActivity(index);
		setSelectedIndex(index);
		setEnabled(true);
	};

	const valueClicked = () => {
		AnalyticsApi.logEvent('Activity Level Selected');
		valueSelected();
	};

	React.useEffect(() => {
		if (typeof goal.activity !== "undefined") {
			setEnabled(true);
		}
	}, []);

	return (
		<div className="content">
			<div style={{ marginBottom: '15px' }}>(not including purposeful exercise)</div>
			<CardCotainer cardList={activities} selectedIndex={selectedIndex} valueSelected={cardClicked}></CardCotainer>

			<div className="">
				{enabled ? (
					<button className="greenButton" onClick={(e) => valueClicked()}>
						Next
					</button>
				) : (
					<button className="lightGrayButton">Next</button>
				)}
			</div>
		</div>
	);
};

export default Activity;
